const urlParams = new URLSearchParams(window.location.search);
let selectedSize = urlParams.get("size");

// progress per size
let sizeStep = { "160ml": 0, "240ml": 0 };

// Require a fresh user action after a size change before showing ATC
let reconfirmGateBySize = { "160ml": false, "240ml": false };

// Track currently selected StarTouch flavour image
let currentStarTouchFlavorSrc = "";

let isClearingFlowSelections = false;

// === step maps ================================================================
const BASE_STEPS = {
  1: ".pplr-bottle-design",
  2: ".pplr-screw-cap",
  3: ".pplr-nipple--straw",
  4: ".pplr-hood",
  5: ".pplr-handle",
};

// dynamic for 240ml BYOB
let step3Selector = ".pplr-screw-cap"; // will flip to ".pplr-startouch-adapter--straw-set"
let STEPS = { ...BASE_STEPS };
let MAX_STEPS = 5;

// straw image
let imgFile = 'BYOB-Customisation-Blurb-DrinknTraining-Straw';

const FLOW_STEP_SELECTORS = [
  ".pplr-bottle-design",
  ".pplr-screw-cap",
  ".pplr-nipple--straw",
  ".pplr-hood",
  ".pplr-handle",
  ".pplr-screw-cap--startouch-adapter--straw-set",
  ".pplr-startouch-adapter--straw-set",
];

function currentBottleSize() {
  return selectedSize || $(".pplr-_bottle-size .pplr-drop-item.active").data("value");
}

function in240mlFlow() {
  const cur = currentBottleSize();
  return !!(cur === "240ml");
}

function isShort240mlPath() {
  return in240mlFlow() && step3Selector === ".pplr-startouch-adapter--straw-set";
}

function rebuildSteps() {
  if (in240mlFlow()) {
    if (isShort240mlPath()) {
      // Short path: final = StarTouch™ adapter & Straw Set section
      STEPS = {
        1: ".pplr-bottle-design",
        2: ".pplr-screw-cap--startouch-adapter--straw-set",
        3: ".pplr-startouch-adapter--straw-set",
      };
      MAX_STEPS = 3;
      $(".pplr-nipple--straw, .pplr-hood, .pplr-handle").removeClass("show-step").hide();
    } else {
      // Full path
      STEPS = {
        1: ".pplr-bottle-design",
        2: ".pplr-screw-cap--startouch-adapter--straw-set",
        3: ".pplr-screw-cap",
        4: ".pplr-nipple--straw",
        5: ".pplr-hood",
        6: ".pplr-handle",
      };
      MAX_STEPS = 6;
    }
  } else {
    STEPS = { ...BASE_STEPS };
    MAX_STEPS = 5;
  }
}

function resetVisibleFlowSteps() {
  const previewSelectors = FLOW_STEP_SELECTORS.map(
    (selector) => `${selector}.pplr_show_preview`
  ).join(", ");

  $(previewSelectors).removeClass("show-step").hide();
}

function clearPersonalizerPreviewLayers() {
  $(".pplr_preview_wrapper .straw-ball-bubble, .pplrabs .straw-ball-bubble-bg").remove();
  $(".pplr_preview_wrapper .startouch-flavor-blurb, .pplrabs .startouch-flavor-blurb-bg").remove();

  $(".pplrabs")
    .find("[style*='background']")
    .not(".pplrabs, .pplrabs > div")
    .remove();

  $(".pplr_preview_wrapper")
    .find("img")
    .not(".product__media img")
    .not("[src*='shopify']")
    .remove();
}

function clearFlowSelections() {
  isClearingFlowSelections = true;

  FLOW_STEP_SELECTORS.forEach((selector) => {
    $(selector).each(function () {
      const $scope = $(this);
      const $deselect = $scope.find(".pplr_deselect").first();

      if ($deselect.length && !$deselect.hasClass("selected")) {
        $deselect.trigger("click");
      }

      $scope.find(".pplr-swatch-element.selected").not(".pplr_deselect").removeClass("selected");
      $scope.find(".pplr-drop-item.active").removeClass("active");
      $scope.find(".pplr_option_text_span").removeClass("has-selection");
    });
  });

  currentStarTouchFlavorSrc = "";
  clearPersonalizerPreviewLayers();

  setTimeout(() => {
    clearPersonalizerPreviewLayers();
    isClearingFlowSelections = false;
  }, 0);
}

// ============================================================================

const blankSteps = { 2: "", 3: "", 4: "" };

function waitForElement(selector) {
  return new Promise((resolve) => {
    const existing = document.querySelector(selector);
    if (existing) return resolve(existing);
    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

function selectNextNonOOSVariant(selector) {
  waitForElement(`${selector} .pplr-swatch-element.vrdisabled`).then(() => {
    const selected = $(`${selector} .pplr-swatch-element.selected`);
    if (!selected.length) {
      $(`${selector} .pplr-swatch-element:not(.vrdisabled)`)[0]?.click();
      if (selector.includes("pplr-nipple--straw")) {
        $(`${selector} .pplr-selecter-selected .ppsrc img`).attr(
          "src",
          $(".pplr-nipple--straw .pplr-selecter-selected .ppsrc img").data("ppsrc")
        );
      }
    }
  });
}

// === StarTouch flavour blurb image ===========================================
function updateStarTouchFlavorBlurb(choiceText) {
  const lower = (choiceText || "").toLowerCase();

  let imgSrc = "";
  if (lower.includes("berry")) {
    imgSrc =
      "https://cdn-zeptoapps.com/images/hkguix-ai.myshopify.com/BYOB-Blurb-Berry-Blast.png?t=1";
  } else if (lower.includes("bubble")) {
    imgSrc =
      "https://cdn-zeptoapps.com/images/hkguix-ai.myshopify.com/BYOB-Blurb-BubblegumPop.png?t=1";
  } else if (lower.includes("mint")) {
    imgSrc =
      "https://cdn-zeptoapps.com/images/hkguix-ai.myshopify.com/BYOB-Blurb-MintToBe.png?t=1";
  }

  // Store current flavour globally
  currentStarTouchFlavorSrc = imgSrc || "";

  // Remove any existing flavour blurb (preview + bg)
  $(".pplr_preview_wrapper .startouch-flavor-blurb, .pplrabs .startouch-flavor-blurb-bg").remove();

  if (!imgSrc) return;

  // Append the new blurb image into the preview + background into scroll container
  $(".pplr_preview_wrapper").append(
    `<img src="${imgSrc}" class="startouch-flavor-blurb" />`
  );
  if (!$(".pplrabs > div .startouch-flavor-blurb-bg").length) {
    $(".pplrabs > div").append(
      `<div style="background:url(${imgSrc})" class="startouch-flavor-blurb-bg" />`
    );
  }
}

// 🔒 single place controlling ATC visibility at step completion
function toNextStep(nextStep) {
  const size = currentBottleSize();
  sizeStep[size] = nextStep;

  // only ever show the preview instance (prevents duplicate sections)
  $(`${STEPS[nextStep]}.pplr_show_preview`).css("display", "block").addClass("show-step");

  if (nextStep === MAX_STEPS) {
    if (isShort240mlPath()) {
      const $starTouchScope = $(`${STEPS[MAX_STEPS]}.pplr_show_preview`);
      const hasChoice =
        $starTouchScope.find(".pplr-swatch-element.selected").length > 0 ||
        $starTouchScope.find(".pplr-drop-item.active").length > 0;
      if (!hasChoice) return;
    }

    // Guard: require a fresh action after a size change
    if (reconfirmGateBySize[size]) return;

    $(".product-form__quantity, .buy-buttons").fadeIn();
  }
}

// --- base listeners ----------------------------------------------------------

// Wait for bottle size
waitForElement(".pplr-_bottle-size").then(() => {
  $(".pplr-_bottle-size .oindexlabel").after(
    '<p class="note">Straw tops and handles are available only when the 240ml bottle is selected.</p>'
  );

  $(document)
    .off("click.byobBottleSize", ".pplr-_bottle-size .pplr-drop-item")
    .on("click.byobBottleSize", ".pplr-_bottle-size .pplr-drop-item", function () {
      const clickedSize = $(this).data("value");

      setTimeout(() => {
        // clean “blank” text noise
        $(".pplr-selecter-selected")
          .contents()
          .filter(function () {
            return this.nodeType === 3 && $.trim(this.nodeValue) === "blank";
          })
          .remove();

        $(".pplr_option_text_span")
          .contents()
          .filter(function () {
            return this.nodeType === 3 && $.trim(this.nodeValue).includes("blank");
          })
          .remove();

        selectedSize =
          clickedSize ||
          $(".pplr-_bottle-size .pplr-drop-item.active").data("value");

        clearFlowSelections();

        // Default step-3 to screw-cap when entering 240ml flow
        if (selectedSize === "240ml") step3Selector = ".pplr-screw-cap";

        // 🔒 Hide ATC and require a fresh confirmation in the new size flow
        $(".product-form__quantity, .buy-buttons").hide();
        reconfirmGateBySize[selectedSize] = true;
        sizeStep[selectedSize] = 0;

        resetVisibleFlowSteps();
        rebuildSteps();
        toNextStep(1);
      }, 0);
    });

  if (selectedSize) {
    $(`.pplr-_bottle-size .pplr-drop-item[data-value="${selectedSize}"]`).trigger("click");
  }
});

// Any meaningful choice in the flow clears the reconfirm gate for the current size
function clearReconfirmGate() {
  const size = currentBottleSize();
  reconfirmGateBySize[size] = false;
}

// Bottle design -> step 2
waitForElement(".pplr-bottle-design").then(() => {
  $(document)
    .off("click.byobBottleDesign", ".pplr-bottle-design .pplr-swatch-element")
    .on("click.byobBottleDesign", ".pplr-bottle-design .pplr-swatch-element", function () {
      if (isClearingFlowSelections) return;
      $(".pplr-bottle-design .pplr_option_text_span").addClass("has-selection");
      rebuildSteps();
      clearReconfirmGate();
      toNextStep(2);
    });
});

// Base screw cap (used as step 2 in 160ml OR step 3 in 240ml full path)
waitForElement(".pplr-screw-cap").then(() => {
  blankSteps[2] = $(".pplr-screw-cap")[0].innerHTML;
  $(document)
    .off("click.byobScrewCap", ".pplr-screw-cap .pplr-swatch-element")
    .on("click.byobScrewCap", ".pplr-screw-cap .pplr-swatch-element", function () {
      if (isClearingFlowSelections) return;
      $(".pplr-screw-cap .pplr_option_text_span").addClass("has-selection");
      rebuildSteps();
      clearReconfirmGate();
      const next = in240mlFlow() ? 4 : 3;
      toNextStep(next);
    });
});

// Nipple / Straw (used in 160ml + 240ml full path)
waitForElement(".pplr-nipple--straw").then(() => {
  $(".pplr-nipple--straw .oindexlabel").after(
    '<p class="note">Unsure of how to choose the right nipple/straw, refer to our <a href="https://pigeon.com.sg/wp-content/uploads/2024/11/SofTouch-Nipple-Guide-How-to-choose.pdf" target="_blank">guide</a> from page 2 onwards.</p>'
  );

  $(".pplr-selecter-selected")
    .contents()
    .filter(function () {
      return this.nodeType === 3 && $.trim(this.nodeValue) === "blank";
    })
    .remove();

  blankSteps[3] = $(".pplr-nipple--straw")[0].innerHTML;

  $(document)
    .off("click.byobNippleStraw", ".pplr-nipple--straw .pplr-swatch-element")
    .on("click.byobNippleStraw", ".pplr-nipple--straw .pplr-swatch-element", function () {
      if (isClearingFlowSelections) return;
      $(".pplr-nipple--straw .pplr_option_text_span").addClass("has-selection");
      if ($(".pplr-nipple--straw .pplr_option_text_span").text().includes("Straw")) {
        imgFile = $(".pplr-nipple--straw .pplr_option_text_span").text().includes("Training") ? 'BYOB-Customisation-Blurb-DrinknTraining-Straw' : 'BYOB-Customisation-Blurb-Drinkn-Straw';
        $(".pplr_preview_wrapper .straw-ball-bubble, .pplrabs .straw-ball-bubble-bg").remove();
        $(".pplr_preview_wrapper").append(
          `<img src="https://cdn-zeptoapps.com/images/hkguix-ai.myshopify.com/${imgFile}.png" class="straw-ball-bubble" />`
        );
        $(".pplrabs > div").append(
          `<div style="background:url(https://cdn-zeptoapps.com/images/hkguix-ai.myshopify.com/${imgFile}.png)" class="straw-ball-bubble-bg" />`
        );
      } else {
        $(".pplr_preview_wrapper .straw-ball-bubble, .pplrabs .straw-ball-bubble-bg").remove();
      }

      rebuildSteps();
      clearReconfirmGate();
      const next = in240mlFlow()
        ? (step3Selector === ".pplr-startouch-adapter--straw-set" ? 4 : 5)
        : 4;
      toNextStep(next);
    });
});

// Hood
waitForElement(".pplr-hood").then(() => {
  blankSteps[4] = $(".pplr-hood")[0].innerHTML;
  $(document)
    .off("click.byobHood", ".pplr-hood .pplr-swatch-element")
    .on("click.byobHood", ".pplr-hood .pplr-swatch-element", function () {
      if (isClearingFlowSelections) return;
      $(".pplr-hood .pplr_option_text_span").addClass("has-selection");
      rebuildSteps();
      clearReconfirmGate();
      toNextStep(in240mlFlow() ? 6 : 5);
    });
});

// Handle (final in full flow)
waitForElement(".pplr-handle").then(() => {
  blankSteps[4] = $(".pplr-hood")[0].innerHTML;
  $(document)
    .off("click.byobHandle", ".pplr-handle .pplr-swatch-element")
    .on("click.byobHandle", ".pplr-handle .pplr-swatch-element", function () {
      if (isClearingFlowSelections) return;
      $(".pplr-handle .pplr_option_text_span").addClass("has-selection");
      rebuildSteps();
      clearReconfirmGate();
      toNextStep(MAX_STEPS);
    });
});

// === 240ml step-2 dropdown -> decide step-3 target (no flavour blurb here) ===
waitForElement(".pplr-screw-cap--startouch-adapter--straw-set").then(() => {
  $(document)
    .off("click.byobStartouchStep", ".pplr-screw-cap--startouch-adapter--straw-set .pplr-drop-item")
    .on("click.byobStartouchStep", ".pplr-screw-cap--startouch-adapter--straw-set .pplr-drop-item", function () {
      if (isClearingFlowSelections) return;
      const clickedChoiceValue = ($(this).data("value") || "").toString();
      const clickedChoiceLabel = ($(this).text() || "").toString();

      setTimeout(() => {
        if (!in240mlFlow()) return;

        const $active = $(".pplr-screw-cap--startouch-adapter--straw-set .pplr-drop-item.active");
        const choiceValue = clickedChoiceValue || ($active.data("value") || "").toString();
        const choiceLabel = clickedChoiceLabel || ($active.text() || "").toString();

        const choiceLower = (choiceValue || choiceLabel).toLowerCase();

        const isStarTouchSet =
          choiceLower.includes("startouch") || choiceLower.includes("star touch");

        step3Selector = isStarTouchSet
          ? ".pplr-startouch-adapter--straw-set"
          : ".pplr-screw-cap";

        // If StarTouch is NOT selected, clear any existing flavor blurbs and reset state
        if (!isStarTouchSet) {
          currentStarTouchFlavorSrc = "";
          $(".pplr_preview_wrapper .startouch-flavor-blurb, .pplrabs .startouch-flavor-blurb-bg").remove();
        }

        rebuildSteps();

        $(".pplr-screw-cap, .pplr-startouch-adapter--straw-set")
          .removeClass("show-step")
          .hide();

        const $target = $(`${step3Selector}.pplr_show_preview`);
        $target.css("display", "block").addClass("show-step");

        clearReconfirmGate();
        toNextStep(3);
      }, 0);
    });
});

// === Dedicated .pplr-startouch-adapter--straw-set swatch block ===============
waitForElement(".pplr-startouch-adapter--straw-set").then(() => {
  $(document)
    .off("click.byobStartouchFlavor", ".pplr-startouch-adapter--straw-set .pplr-swatch-element")
    .on("click.byobStartouchFlavor", ".pplr-startouch-adapter--straw-set .pplr-swatch-element", function () {
      if (isClearingFlowSelections) return;
      $(".pplr-startouch-adapter--straw-set .pplr_option_text_span").addClass("has-selection");

      // Determine the chosen flavour text for the blurb – prefer option text span, fallback to swatch text
      const flavourText =
        $(".pplr-startouch-adapter--straw-set .pplr_option_text_span").text() ||
        $(this).text() ||
        "";

      updateStarTouchFlavorBlurb(flavourText);

      rebuildSteps();
      clearReconfirmGate();

      // In short path, this is MAX_STEPS (3) so ATC shows after selection
      toNextStep(3);
    });
});

function syncPersonalizationScrollContainer() {
  if (!$(".pplrabs").length) return;

  // Existing nipple straw visual logic
  if (
    $(".pplr-nipple--straw.pplr_show_preview .pplr_option_text_span")
      .text()
      .includes("Straw") &&
    !$(".pplrabs > div .straw-ball-bubble-bg").length
  ) {
    $(".pplrabs > div").append(
      `<div style="background:url(https://cdn-zeptoapps.com/images/hkguix-ai.myshopify.com/${imgFile}.png)" class="straw-ball-bubble-bg" />`
    );
  } else if (
    !$(".pplr-nipple--straw.pplr_show_preview .pplr_option_text_span")
      .text()
      .includes("Straw")
  ) {
    $(".pplrabs .straw-ball-bubble-bg").remove();
  }

  // 🔁 Ensure StarTouch flavour blurb persists across re-renders / scroll
  const hasFlavor = !!currentStarTouchFlavorSrc;

  if (hasFlavor) {
    if (!$(".pplr_preview_wrapper .startouch-flavor-blurb").length) {
      $(".pplr_preview_wrapper").append(
        `<img src="${currentStarTouchFlavorSrc}" class="startouch-flavor-blurb" />`
      );
    }
    if (!$(".pplrabs > div .startouch-flavor-blurb-bg").length) {
      $(".pplrabs > div").append(
        `<div style="background:url(${currentStarTouchFlavorSrc})" class="startouch-flavor-blurb-bg" />`
      );
    }
  } else {
    $(".pplr_preview_wrapper .startouch-flavor-blurb, .pplrabs .startouch-flavor-blurb-bg").remove();
  }
}

// personalization scroll container (for straw-ball background + StarTouch blurbs)
let personalizationScrollObserverStarted = false;
function waitForPersonalizationScrollContainer() {
  if (personalizationScrollObserverStarted) return;
  personalizationScrollObserverStarted = true;

  waitForElement(".pplrabs").then(() => {
    syncPersonalizationScrollContainer();

    const observer = new MutationObserver(() => {
      syncPersonalizationScrollContainer();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
}
waitForPersonalizationScrollContainer();

// price clone
waitForElement(".product__info-container .price").then(() => {
  $(".product-form__quantity").before($(".product__info-container .price").clone());
});

$(function () {
  $("body").addClass("byob");
  $(".product-form__quantity, .buy-buttons").hide();
  rebuildSteps(); // initialize the correct step map on load
});
